import { push } from '@lagunovsky/redux-react-router'
import { all, call, put, takeLatest } from 'redux-saga/effects'

import { callApiAsync } from 'services/api/callAPIAsync'
import { delay } from '../../global/helpers'

import { PATH_NAME } from 'app/constants'
import { startLoading, stopLoading } from 'components/Loader/LoaderPopup/reducer'
import { setErrorMessage, setSuccessMessage } from 'components/Windows/CentralMessagesList/reducer'
import gtmChangePasswordError from 'services/gtm/gtmChangePasswordError'
import gtmChangePasswordSuccess from 'services/gtm/gtmChangePasswordSuccess'
import { changeForgottenPassword, setDisabled, setError } from './reducer'

function* changeForgottenPasswordCallSaga(action) {
    const password = action?.payload?.password
    const new_password = action?.payload?.confirmNewPassword
    const email = action?.payload?.email
    const validity = action?.payload?.validity
    const control = action?.payload?.control

    if (!email || !validity || !control || !password || !new_password) {
        yield put(setError(true))
        yield put(setDisabled(true))
        return
    }

    yield put(setError(null))

    yield put(startLoading())

    const { error } = yield call(callApiAsync, 'changeForgottenPassword', {
        password,
        new_password,
        email,
        validity,
        control,
    })
    yield delay(3000)
    yield put(stopLoading())

    if (error) {
        gtmChangePasswordError()
        yield put(setErrorMessage(error))
        control.error(error)
        return
    }

    yield put(setSuccessMessage('CHANGE_FORGOTTEN_PASSWORD'))

    gtmChangePasswordSuccess()
    yield put(push(PATH_NAME.LOGIN))
}

export default function* changeForgottenPasswordSaga() {
    yield all([takeLatest(changeForgottenPassword.type, changeForgottenPasswordCallSaga)])
}
